// extracted by mini-css-extract-plugin
export default {"Part6":"part6_Part6__kv7YL","inner":"part6_inner__sbS3k"};